<template>
  <div>
    <div class="box-filter">
      <StatusUpdateDados />
      <FilterDatepicker @getDataSelect="setDataFilter" />
    </div>

    <div class="primary">
      <div class="box table">
        <HeaderGraphic :data="topMarcas" />

        <div class="painel">

          <div class="empty" v-if="loading">
            <p>{{ __e('LOADING') }}</p>
          </div>

          <div class="empty" v-if="!loading && getMarcas.total == 0">
            <p>{{ __e('NO_DATA') }}</p>
          </div>

          <div class="graphic-horizontal" v-if="!loading && getMarcas.total > 0">
            <div class="line" v-for="item in topMarcas.items" :key="item.marca">
              <div class="title">{{ item.marca }}</div>
              <div class="box-g">
                <div class="bg"></div>
                <div class="box-bar">
                  <div class="bar" :style="'width: ' + item.percent + '%'"></div>
                  <div class="number">
                    {{ item.valor_vendido }}
                    <span class="badge badge--success"
                      title="Participação nas vendas com base no período selecionado"
                      v-b-tooltip.hover.top>{{item.period_percent | percentage(false) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box table">
        <div class="box__header">
          <HeaderGraphic :data="marcas" />
          <DownloadCsvButton :onDownload="downloadCSV" />
        </div>
        <div class="painel">

          <div class="empty" v-if="loading">
            <p>{{ __e('LOADING') }}</p>
          </div>

          <div class="empty" v-if="!loading && getMarcas.total == 0">
            <p>{{ __e('NO_DATA') }}</p>
          </div>

          <b-table v-if="!loading && getMarcas.total > 0" :items="marcas.items"></b-table>
          <paginate
            v-if="!loading && lastPage > 1"
            v-model="currentPage"
            :page-count="lastPage"
            :prev-text="'‹'"
            :next-text="'›'"
            :container-class="'pagination'"
            :page-class="'page-item'"
          ></paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DownloadCsvButton from "@/components/download-button/DownloadCsvButton.vue";
import FilterDatepicker from "@/components/filter-datepicker/FilterDatepicker.vue";
import HeaderGraphic from "@/components/header-graphic/HeaderGraphic.vue";
import StatusUpdateDados from "@/components/status-update-dados/StatusUpdateDados.vue";
import { listarMarcas, getCSV } from "@/api/marcas";
import { numberToReal } from '@/utils/money';
import { percentage } from '@/utils/masks';
import { __e } from "@/utils/messages";

export default {
  components: {
    DownloadCsvButton,
    HeaderGraphic,
    FilterDatepicker,
    StatusUpdateDados,
  },
  filters: {
    percentage
  },
  data() {
    return {
      loading: true,
      topMarcas: {},
      marcas: {},
      perPage: 15,
      currentPage: 1,
      start: null,
      end: null,
    };
  },
  mounted() {
    this.loadData();
  },
  computed: {
    ...mapState({
      accountActive: state => state.accounts.accountActive,
      getMarcas: state => state.marcas.marcas,
      lastPage: state => state.marcas.marcas_last_page,
    }),
  },
  methods: {
    __e,
    listarMarcas,
    getCSV,
    downloadCSV() {
      this.getCSV(this.start, this.end);
    },
    loadData() {
      this.listarMarcas(this.start, this.end, this.perPage, this.currentPage);
    },
    setDataFilter({ start, end }) {
      (this.start = start), (this.end = end);
      this.listarMarcas(start, end, this.perPage, this.currentPage);
    },

    loadTopMarcas(value) {
      const items = [];
      const size = 8;
      if (value.data) {
        value.data.slice(0, size).map(line => {
          const percent = (line.valor_vendido * 100) / value.data[0].valor_vendido;
          let valorReal = numberToReal(line.valor_vendido);
          items.push({
            marca: line.brandName,
            period_percent: line.period_percent,
            valor_vendido: valorReal,
            percent,
          });
        });
      }

      let data = {
        title: {
          top: "Top",
          name: "Marcas no período",
        },
        legenda: [
          {
            title: "Top 3",
            color: "#FD3064",
          },
          {
            title: "Outras",
            color: "#2c2c2c",
          },
        ],
        items,
      };
      return (this.topMarcas = data);
    },

    loadTable(value) {
      const items = [];

      if (value.data) {
        value.data.map(line => {
          items.push({
            marca: line.brandName,
            Receita: numberToReal(line.valor_vendido),
            "Ticket Médio": numberToReal(line.ticket_medio),
            "Total de Pedidos": line.qtd_pedidos
            // "Produtos vendidos": line.qtd_itens_vendidos,
          });
        });
      }

      let data = {
        title: {
          top: "",
          name: "Detalhamento",
        },
        items,
      };
      return (this.marcas = data);
    },
  },
  watch: {
    getMarcas(newData) {
      if (newData) {
        this.loadTable(newData);
        this.loadTopMarcas(newData);
      }
      this.loading = false;
    },
    currentPage(newPage) {
      this.currentPage = newPage;
      this.listarMarcas(this.start, this.end, this.perPage, this.currentPage);
    },
    accountActive(data) {
      if (data) this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
.graphic-horizontal {
  .line {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: column;
    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(3) {
      .box-g {
        .box-bar {
          .bar {
            background-color: #fd3064;
          }
        }
      }
    }
    .title {
      flex: 1;
      // max-width: 150px;
      font-size: 16px;
      text-align: left;
      padding: 15px 15px 8px 0;
    }
    .box-g {
      flex: 1;
      width: 100%;
      .box-bar {
        display: flex;
        align-items: center;
        max-width: 700px;
        .bar {
          height: 20px;
          background-color: #2c2c2c;
          border-radius: 50px;
        }
        .number {
          margin-left: 15px;
          color: #2c2c2c;
          font-size: 16px;
          white-space: nowrap;
        }
      }
    }
  }
}

.box-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.categorias {
  height: 100%;
  .page-container {
    margin: 30px 0;
  }
}

.small {
  max-width: 600px;
  margin: 150px auto;
}

.primary {
  display: flex;
  flex-wrap: wrap;
}

.box {
  display: flex;
  flex-direction: column;
  margin-right: 15px;
  max-width: calc(50% - 7.5px);
  width: 100%;
  position: relative;
  background-color: #fff;
  padding: 18px;
  box-shadow: 0 3px 6px #c3d0e029;
  border-radius: 20px;
  height: 400px;
  &:nth-child(2) {
    margin-right: 0;
  }
  &__header {
    display: flex;
    justify-content: space-between;
  }
  .painel {
    position: relative;
    height: 300px;
    display: block;
    overflow: hidden;
    .table {
      td[aria-colindex="4"],
      td[aria-colindex="5"] {
        white-space: nowrap;
        text-align: center;
      }
    }
  }
  &.table {
    margin: 0;
    max-width: calc(50% - 15px);
    margin-left: 15px;
    height: auto;
    thead {
      display: inherit !important;
    }
    &:after {
      content: "";
      display: block;
    }

    &:first-child {
      max-width: calc(50% - 15px);
      margin: 0;
      margin-right: 15px;
      display: inline-table;
    }

    .painel {
      height: auto;
      overflow: inherit;
    }
  }
}

@media only screen and (max-width: 991px) {
  .primary {
    flex-direction: column;
  }
  .box {
    &.table {
      max-width: 100%;
      margin-top: 30px;
      margin-left: 0;
      &:first-child {
        max-width: 100%;
        margin-top: 0;
      }
    }
  }
}

@media only screen and (max-width: 1250px) {
  .graphic-horizontal {
    .line {
      .title {
        max-width: 80px;
        overflow: hidden;
        font-size: 14px;
      }
      .box-g {
        .box-bar {
          .number {
            font-size: 17px;
          }
        }
      }
    }
  }
  .box-filter {
    justify-content: flex-end;
  }

  .primary {
    flex-direction: column;

    .box {
      &.table {
        max-width: 100%;
        margin-top: 30px;
        margin-left: 0;
        padding: 25px;
        overflow-x: scroll;
        &:first-child {
          margin-top: 0;
        }
      }
    }
  }
}
</style>
